/**
 * useEVProjects Hook
 *
 * Wrapper around useUnifiedProjects for Flux EV app.
 * Provides CRUD operations for EV projects via the unified project system.
 */

import { useUnifiedProjects } from '@vortx/shared-ui';

export function useEVProjects() {
    return useUnifiedProjects('flux_ev');
}
